import { useCallback, useRef, useState } from 'react';

import { getPaymentsStatuses as getPaymentsStatusesRequest } from 'PrivateAPI';

import { captureExceptionWithTeam } from 'Utilities/captureException/captureExceptionWithTeam';
import { TEAM } from 'Utilities/constants';

import { PaymentStatuses } from 'Containers/app/payments/Payments.types';

import { getMWVsSellerData } from '../../hooks/useLatestPayments.helper';

export const useGetPaymentsStatuses = () => {
  const [data, setData] = useState<PaymentStatuses | null>();
  const [isFetched, setIsFetched] = useState<boolean>(false);
  const cancelled = useRef(false);

  const resolve = useCallback((newData: typeof data) => {
    if (cancelled.current) {
      return;
    }

    setData(newData);
  }, []);

  const getPaymentsStatuses = useCallback(async (dpEnquiryId: number) => {
    try {
      const response: ApiResponseForJsend<
        NonNullable<typeof data>[]
      > = await getPaymentsStatusesRequest(dpEnquiryId, undefined);

      if (response.status === 'success') {
        const mwToSeller = getMWVsSellerData(response.data);

        resolve(mwToSeller ? { ...mwToSeller } : null);
      }
    } catch (err) {
      resolve(null);

      captureExceptionWithTeam(
        err,
        TEAM.PAYMENTS_FE,
        {
          extra: {
            dpEnquiryId,
          },
          tags: {
            fetch: 'useGetPaymentsStatuses',
          },
        },
      );
    } finally {
      setIsFetched(true);
    }
  }, [resolve]);

  return {
    data,
    getPaymentsStatuses,
    isFetched,
  };
};
